<template>
  <div class="modal" :style="{  display: display }">
    <div id="backgroundElement" :style="{  display: display, opacity: opacity}"></div>
    <div id="divElement" :style="{  display: display, opacity: opacity, transform: scale}">
      <div id="containerElement">
        <div id="headerElement" class="bannerClass" :style="{opacity: opacity}">
          <div class="hh2">САЙТУ</div>нужна твоя
          <br />поддержка
        </div>
        <div id="footerElement" class="bannerClass" :style="{opacity: opacity}">
          <div class="hh2">А ТЫ</div>
          <div id="footerHeader" :style="{opacity: opacity}">
            отключил блокировку
            <br />рекламы?
          </div>
        </div>
        <div
          @click="close()"
          id="buttonElement"
          class="bannerClass"
          :style="{opacity: opacity}"
        >конечно</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      display: "none",
      msg: "none",
      opacity: "0",
      scale: "scale(1)"
    };
  },
  created() {},

  mounted() {
    let img1 = new Image();
    img1.src = "/request/img/myzhchina.png";
    img1.addEventListener("load", this.loaded);
    let base = 768;
    let min =
      window.innerWidth > window.innerHeight
        ? window.innerHeight
        : window.innerWidth;
    min = min > base ? base : min;
    this.scale = `scale(${min / base})`;
  },
  methods: {
    loaded() {
      console.log("loaded");
      let r = Math.floor(Math.random() * 10);
      console.log(r);
      if (!document.getElementById("777777777") && r == 0) {
        this.display = "block";
        setTimeout(() => {
          this.opacity = "100";
        }, 500);
      }
    },
    close() {
      this.display = "none";
    }
  }
};
</script>

<style>
.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 10; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}

.hh2 {
  font-size: 1.5em;
  display: block;
  line-height: 1.6em;
}
#divElement {
  background-image: radial-gradient(#f002, #000 50%, #0000 60%, #0000 100%),
    url(assets/myzhchina.png);
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -300px;
  margin-left: -300px;
  width: 600px;
  height: 600px;
  z-index: 200;
  border-radius: 50%;
  transform-origin: center center;
  transition: all 1s cubic-bezier(0.42, 0, 1, 1);
}
#backgroundElement {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 10; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  filter: grayscale(0.5) blur(10px);
}
#containerElement {
  position: relative;
  width: 600px;
  height: 600px;
}

.bannerClass {
  color: aliceblue;
  font-size: 32px;
  font-family: Cambria, Cochin, Georgia, Times, "Times New Roman", serif;
  position: absolute;
  width: 100%;
  text-align: center;
  transform-origin: center center;
}
#headerElement {
  top: 40px;
}

#footerHeader {
  transition: all 1s cubic-bezier(0.42, 0, 1, 1) 2s;
}

#footerElement {
  bottom: 60px;
  transition: all 1s cubic-bezier(0.42, 0, 1, 1) 1s;
}
#buttonElement {
  border-radius: 5px;
  padding: 4px;
  background-color: black;
  bottom: -60px;
  left: 200px;
  transition: all 1s cubic-bezier(0.42, 0, 1, 1) 4s;
  color: aliceblue;
  width: 200px;
  cursor: pointer;
}
#buttonElement:hover {
  color: #f00;
  transition: all 0.5s;
}
</style>
